import React from "react";
import Lottie from "lottie-react";

const LottieView = React.forwardRef(({ source, ...rest }, ref) => {
  return <Lottie {...rest} lottieRef={ref} animationData={source} />;
});

export default LottieView;
